import './App.css';
import HomePage from './Components/HomePage/HomePage';

const App = () => {
    return <div className='wrapper'>
        <HomePage/>
    </div>
};

//导出组件
export default App;